import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "内容分类",
    links: [
      { label: "电影", to: "/category?type=movie" },
      { label: "电视剧", to: "/category?type=tv" },
      { label: "新片速递", to: "/category?topic=new-release" },
      { label: "高分必看", to: "/category?topic=top-rated" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "使用说明", to: "/about" },
      { label: "版权声明", to: "/about" },
      { label: "意见反馈", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full border-t border-primary-900 bg-primary-950">
      <div className="mx-auto w-full px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500">
                <i className="ri-film-fill text-lg text-foreground-50" />
              </span>
              <span className="font-heading text-base font-bold text-foreground-50">
                欧美精品在线观看
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-400">
              专注欧美电影与电视剧的推荐与资料整理平台，覆盖最新上线与经典片单，
              为喜爱欧美影视的观众提供清晰、专业的浏览与查找体验。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-weibo-fill", label: "微博" },
                { icon: "ri-wechat-fill", label: "微信" },
                { icon: "ri-youtube-fill", label: "视频号" },
                { icon: "ri-mail-fill", label: "邮箱" },
              ].map((social) => (
                <button
                  key={social.label}
                  type="button"
                  aria-label={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-700 text-foreground-300 transition-colors hover:border-accent-500 hover:text-accent-400 cursor-pointer"
                >
                  <i className={`${social.icon} text-base`} />
                </button>
              ))}
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-100">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 transition-colors hover:text-accent-400 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 欧美精品在线观看 · 本站内容与影视资料仅用于展示与推荐
          </p>
          <p className="text-xs text-foreground-500">
            联系邮箱：contact@example.com
          </p>
        </div>
      </div>
    </footer>
  );
}